import React from 'react';
import Header from '@/components/Header';
import Selector from '@/components/PDF/Selector';
import { SafeAreaView } from 'react-native-safe-area-context';

export default function PDFViewer() {
  return (
    <SafeAreaView style={{ width:'100%', flex: 1, margin:0, padding: 0 }}>
      <Header />
      <Selector />
    </SafeAreaView>
  );
}